import { render } from "./DatagridHeaderColumns.vue?vue&type=template&id=97d7dd6c"
import script from "./DatagridHeaderColumns.vue?vue&type=script&lang=js"
export * from "./DatagridHeaderColumns.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__